/**
 * Translation mappings for mobile navigation items
 */

import { generateSlug } from "../../../../utils/slugUtils";

/**
 * Get translated product item name
 */
export const translateProductItem = (item, t) => {
  const mapping = {
    "TadReamk Eye": t("products.tadreamkEye"),
    "TadReamk Create": t("products.tadreamkCreate"),
    "TadReamk Patent": t("products.tadreamkPatent"),
    "TadReamk Surveillance": t("products.tadreamkSurveillance"),
    "Trademark Trading": t("products.trademarkTrading"),
    "Business Card Manager": t("products.businessCardManager"),
  };
  return mapping[item] || item;
};

/**
 * Get translated magazine item name
 */
export const translateMagazineItem = (item, t) => {
  const mapping = {
    "IP Law": t("magazine.ipLaw"),
    "TadReamk AI": t("magazine.tadreamkAI"),
    "TadReamk Design": t("magazine.tadreamkDesign"),
    "TadReamk-AIGC": t("magazine.tadreamkAIGC"),
    "TadReamk-ERP": t("magazine.tadreamkERP"),
  };
  return mapping[item] || item;
};

/**
 * Get path for magazine item
 */
export const getMagazineItemPath = (item) => {
  switch (item) {
    case "TadReamk AI":
      return "/magazine/ai";
    case "TadReamk Design":
      return "/magazine/design";
    case "IP Law":
      return "/magazine/law";
    case "TadReamk-AIGC":
      return "/magazine/aigc";
    case "TadReamk-ERP":
      return "/magazine/erp";
    default:
      return `/magazine/${generateSlug(item)}`;
  }
};

/**
 * Get translated business item name
 */
export const translateBusinessItem = (item, t) => {
  const mapping = {
    Overview: t("business.overview"),
    "API Documentation": t("business.apiDocumentation"),
    "Contact Sales": t("business.contactSales"),
    Pricing: t("business.pricing"),
  };
  return mapping[item] || item;
};

/**
 * Get path for business item
 */
export const getBusinessItemPath = (item) => {
  switch (item) {
    case "Overview":
      return "/business/overview";
    case "API Documentation":
      return "/business/api";
    case "Contact Sales":
      return "/business/contact";
    case "Pricing":
      return "/business/pricing";
    default:
      return `/business/${generateSlug(item)}`;
  }
};

/**
 * Get translated company item name
 */
export const translateCompanyItem = (item, t) => {
  const mapping = {
    "About Us": t("companyLinks.aboutUs"),
    Careers: t("companyLinks.careers"),
  };
  return mapping[item] || item;
};

/**
 * Get path for company item
 */
export const getCompanyItemPath = (item) => {
  switch (item) {
    case "About Us":
      return "/about";
    case "Careers":
      return "/careers";
    case "News":
      return "/news";
    default:
      return `/${generateSlug(item)}`;
  }
};

/**
 * Get translated AI service item name
 */
export const translateAIServiceItem = (item, t) => {
  const mapping = {
    "Lace Material": t("products.laceMaterial"),
  };
  return mapping[item] || item;
};
